// extracted by mini-css-extract-plugin
export default {"switchContainer":"styles_switchContainer__2BntJ","switch":"styles_switch__WrjEu","slider":"styles_slider__L4Szy"};